
const appInfo = {
    title: 'AXPC Members',
    version: '1.0.0',
    company: 'American Exploration & Production Council',
    company_address: '999 E Street NW, Suite 200 Washington, DC 20004',
    app_website_name: 'AXPC Members',
    app_website: 'http://members.axpc.org',
    company_email: 'info@axpc.com'
};
export default appInfo;
